import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './WelcomeCard.css';

const WelcomeCard = () => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Only show welcome card on home page
    if (location.pathname === '/') {
      setIsVisible(true);
      
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000); // Show for 3 seconds

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  // Only show on home page and if visible
  if (location.pathname !== '/' || !isVisible) return null;

  return (
    <div className="welcome-card-overlay">
      <div className="welcome-card">
        <div className="welcome-card__content">
          <div className="welcome-card__illustration">
            <img
              src="/assets/Namaste.webp"
              alt="Namaste - Welcome to At Every Desk - Compostable Packaging for the Globe"
              width={240}
              height={240}
              decoding="async"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/assets/Namaste.png';
              }}
            />
          </div>
          <div className="welcome-card__subtitle">Pioneering Sustainable Packaging for the Globe</div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;

